module.exports = __webpack_public_path__ + "static/img/18.818eb15.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/18.png
// module id = GFAv
// module chunks = 7